import { render, staticRenderFns } from "./ReceiveCheck.vue?vue&type=template&id=004628f8&"
import script from "./ReceiveCheck.vue?vue&type=script&lang=js&"
export * from "./ReceiveCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports